import React from "react";

import { loanFormFieldType } from "features/loanApplications/formFieldsConfig";
import { StepperItem } from "./StepperItem";

interface ApplicationStepperProps {
  onStepChange: (stepIndex: number) => void;
  currentStep: number;
  stepsDetails: loanFormFieldType[];
}

export function ApplicationStepper({
  stepsDetails,
  onStepChange,
  currentStep,
}: ApplicationStepperProps) {
  // Handle step click and update both query params and parent state
  const handleStepClick = (index: number) => {
    if (index !== currentStep) {
      onStepChange(index);
    }
  };

  return (
    <div className="flex items-center gap-1 justify-between w-full">
      {stepsDetails.map((step, index) => (
        <React.Fragment key={index}>
          <StepperItem
            stepNumber={index + 1}
            stepName={step.section}
            isCurrentStep={currentStep === index}
            isCompleted={currentStep > index}
            onClick={() => handleStepClick(index)}
            isLastStep={index === stepsDetails.length - 1}
          />
        </React.Fragment>
      ))}
    </div>
  );
}
